// extracted by mini-css-extract-plugin
export var centrecardcontainer = "CentreMapOverlayCard-module--centrecardcontainer--ae80f";
export var centrecardimage = "CentreMapOverlayCard-module--centrecardimage--dccb9";
export var centrecardimagewrapper = "CentreMapOverlayCard-module--centrecardimagewrapper--4d334";
export var centrelocation = "CentreMapOverlayCard-module--centrelocation--a07ad";
export var centrename = "CentreMapOverlayCard-module--centrename--2e9b2";
export var distance = "CentreMapOverlayCard-module--distance--9b9e5";
export var middlecontainer = "CentreMapOverlayCard-module--middlecontainer--b1d8e";
export var rightcontainer = "CentreMapOverlayCard-module--rightcontainer--a4eea";